import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  Button,
  InputAdornment,
  makeStyles,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";

import useTabStyles from "../../styles/Tab.style";
import useStyles from "./BaseAccountConfTab.style";
import Paginator, { DataTypeEnum } from "../../../../models/Paginator";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../context/ICIPAdminContext";
import ICIPAdminService from "../../../../services/ICIPAdminService";
import CurrencyService from "../../../../services/CurrencyService";
import { AddBaseAccountConf} from "./components/AddBaseAccountConf";
import { EditBaseAccountConf} from "./components/EditBaseAccountConf";
import Grid from "@material-ui/core/Grid";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/TableData";
import CountryService from "../../../../services/CountryService";
import PricingGroupService from "../../../../services/PricingGroupService";
import { InputField } from "../../../../components/input-field/InputField";
import { Autocomplete } from "@material-ui/lab";
import BaseAccountConfigurationService from "../../../../services/BaseAccountConfigurationService";
import BaseAccountConfiguration from "../../../../models/BaseAccountConfiguration";
import { InputDate } from "../../../../components/input-date/InputDate";
import moment from "moment";
import { BorderAll, CalendarToday } from "@material-ui/icons";
import { FormikHelpers, useFormik } from "formik";

interface BaseAccountConfTabProps {}

export interface BaseAccountConfTabData {
  original: Paginator;
  filtered: Paginator;
}

export const BaseAccountConfTab = (props: BaseAccountConfTabProps) => {
  const classes = useStyles();
  const tabClasses = useTabStyles(props);
  const intl = useIntl();
  const { formatMessage } = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [paginator, setPaginator] = useState((): Paginator => null);
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [pricingGroups, setPricingGroups] = useState([]);
  const [modalType, setModalType] = useState(true);
  const [selectedBaseAccount, setSelectedBaseAccount] = useState(null);
  const [editBaseAccountModalOpened, setEditBaseAccountModalOpened] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [error, setError] = useState(null);

  const formik = useFormik({
    initialValues: {
      credit_base: "",
      assignment_date: "",
      pricing_group_id: "",
      currency_id: "",
      country_id: "",
    },
    /*validationSchema: Yup.object().shape({
      credit_base: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCreditBase" })
      ),
      assignment_date: Yup.string().required(
        formatMessage({ id: "sharedScreen.pleaseEnterAssignmentDate" })
      ),
      pricing_group_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterPricingGroup" })
      ),
      currency_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCurrency" })
      ),
      country_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCountry" })
      ),
    }),*/
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      setError(false);
      /*try {
        const addBaseAccountResult = await BaseAccountConfigurationService.addBaseAccountConf(formik.values);
        if (addBaseAccountResult.isSuccess && addBaseAccountResult.data.code === 100) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          onSubmitCallback();
        } else {
          setError(true);
          if (addBaseAccountResult.data.code === 101) {
            setErrorMessage("Similar base account configuration already exist");
          } else {
            setErrorMessage("");
          }
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);*/
    },
  });

  // Callbackyy
  const openEditModal = (e, data) => {
    setModalType(false);
    setSelectedBaseAccount(data);
    if (editBaseAccountModalOpened !== true) {
      toggleEditBaseAccountModal();
    }
  };

  const toggleEditBaseAccountModal = () => {
    setEditBaseAccountModalOpened(!editBaseAccountModalOpened);
    setModalType(!modalType);
  };

  const handleDataChange = (name: string, value: string) => {
    let currentSearchData = { ...searchData };
    currentSearchData[name] = value;
    setSearchData(currentSearchData);
    console.log(currentSearchData);
  };

  const paginatorAction = (page: number) => {
    fetchData(page);
  };

  const handleSearchData = () => {
    BaseAccountConfigurationService.searchBaseAccountConfig(searchData).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.baseAccountConf
        );
        setPaginator(reqPaginator);
      } else {
        setError(true);
      }
      console.log(paginator);
    });
  };

  // Fetch data

  const fetchData = (page: number = 1) => {
    BaseAccountConfigurationService.getAll(page).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let reqPaginator = Paginator.fromJson(
          JSON.parse(JSON.stringify(response.data.data)),
          DataTypeEnum.baseAccountConf
        );
        setPaginator(reqPaginator);

        dispatch({
          type: ICIPAdminActionTypeEnum.loaded,
        });
      } else {
        dispatch({
          type: ICIPAdminActionTypeEnum.error,
          data: {
            error: intl.formatMessage({ id: "error.unknownError" }),
          },
        });
      }
    });
  };

  const loadCurrencies = () => {
    const response = CurrencyService.supportedCurrencies();

    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let currencies = JSON.parse(JSON.stringify(response.data.data));
        setCurrencies(currencies);
      } else {
        setCurrencies(currencies);
      }
    });
  };

  const loadCountries = () => {
    const response = CountryService.supportedCountries();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let countries = JSON.parse(JSON.stringify(response.data.data));
        setCountries(countries);
      } else {
        setCountries(countries);
      }
    });
  };

  const loadPricingGroups = () => {
    const response = PricingGroupService.getAllPricingGroup();
    response.then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        let pg = JSON.parse(JSON.stringify(response.data.data));
        setPricingGroups(pg);
      } else {
        setPricingGroups(pricingGroups);
      }
    });
  };

  useEffect(() => {
    dispatch({ type: ICIPAdminActionTypeEnum.loading });
    fetchData();
    loadCurrencies();
    loadCountries();
    loadPricingGroups();
    //handleSearchData();
  }, []);

  const handleDateChange = (name: string, dateString: string) => {
    formik.setValues({ ...formik.values, [name]: dateString });

    let currentSearchData = { ...searchData };
    currentSearchData[name] = dateString;
    setSearchData(currentSearchData);
    console.log(currentSearchData);
  };

  // Renders

  const render = () => {
    return (
      <Box component="div" className={classes.tabsPanel}>
        <Box component="div" className={classes.wrapper}>
          <Box component="div" className={classes.leftHeader}>
            <Typography variant="h3" component="h3">
              <FormattedMessage id="sharedScreen.baseAccountConf" />
            </Typography>
            <Box component="div" className={classes.trailing}>
              <Typography variant="h3" component="h3">
                {`# ${paginator.total}`}
              </Typography>
            </Box>
          </Box>
        </Box>
       <Grid item xs={12} sm={12} lg={12} className={classes.searchGroup}>
          <Grid item xs={3} sm={6} lg={2} className={classes.testField}>
            <InputField
              className={classes.testField}
              type="number"
              fullWidth
              label={formatMessage({ id: "sharedScreen.searchCreditBase" })}
              placeholder={formatMessage({ id: "sharedScreen.creditBase" })}
              name="credit_base_search"
              onChange={(event) =>
                handleDataChange(event.target.name, event.target.value)
              }
            />
          </Grid>
          <Grid item xs={3} sm={6} lg={3} className={classes.fieldDate}>
                <InputDate
                  minDate={moment()
                    .subtract("year", 2)
                    .format("YYYY-MM-DD HH:mm:ss")}
                  onDateChange={(name, date) => handleDateChange(name, date)}
                  inputProps={{
                    disabled: formik.isSubmitting,
                    fullWidth: true,
                    style:{height: 40},
                    id: "assignment_date",
                    name: "assignment_date",
                    label: intl.formatMessage({
                      id: "sharedScreen.searchAssignmentDate"}),
                    placeholder: intl.formatMessage({
                      id: "sharedScreen.assignmentDate",
                    }),
                    endAdornment: (
                      <InputAdornment position="start">
                        <CalendarToday />
                      </InputAdornment>
                    ),
                    value: formik.values.assignment_date,
                    error:
                      Boolean(formik.touched.assignment_date) &&
                      Boolean(formik.errors.assignment_date),
                    helperText:
                      formik.touched.assignment_date &&
                      formik.errors.assignment_date,
                  }}
                  pickerProps={{
                    format: "YYYY-MM-DD HH:mm:ss",
                    disabled: false,
                    showToday: false,
                    showTime: true,
                    allowClear: true,
                  }}
                />
          </Grid>
          <Grid item xs={3} sm={3} lg={3} className={classes.testField1}>
            <Autocomplete
              id="pricingGroups"
              options={pricingGroups}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchPricingGroup",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(event, searchPricingGroup) => {
                handleDataChange("pricing_group", searchPricingGroup);
              }}
            />
          </Grid>
          <Grid item xs={3} sm={3} lg={3} className={classes.testField1}>
            <Autocomplete
              id="currencies"
              options={currencies}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchCurrency",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.code}
              //onChange={formik.handleChange}
              onChange={(event, searchCurrency) => {
                handleDataChange("currency", searchCurrency);
              }}
            />
          </Grid>
          <Grid item xs={3} sm={3} lg={3} className={classes.testField1}>
            <Autocomplete
              id="countries"
              options={countries}
              renderInput={(param) => (
                <TextField
                  {...param}
                  label={formatMessage({
                    id: "sharedScreen.searchCountry",
                  })}
                  variant="outlined"
                  size="small"
                />
              )}
              getOptionLabel={(Option) => Option.designation}
              //onChange={formik.handleChange}
              onChange={(event, searchCountry) => {
                handleDataChange("country", searchCountry);
              }}
            />
          </Grid>
          
          <Grid item xs={3} sm={3} lg={4} className={classes.testField}>
            <Button
              color="secondary"
              variant="contained"
              className={classes.testField1}
              onClick={handleSearchData}
            >
              <FormattedMessage id="sharedScreen.searchPricing" />
            </Button>
          </Grid>
        </Grid>
        <br />
        <br />

        <TableData
          paginator={
            paginator.total !== 0
              ? {
                  total: paginator.total,
                  page: paginator.page,
                  totalPage: paginator.total_page,
                  title: "",
                  handlePrevAction:
                    paginator.prev_page !== null
                      ? () => paginatorAction(paginator.page - 1)
                      : null,
                  handleNextAction:
                    paginator.next_page !== null
                      ? () => paginatorAction(paginator.page + 1)
                      : null,
                }
              : null
          }
          rows={renderBaseAccountConfTableRows()}
          header={renderBaseAccountConfTableHeader()}
        />
      </Box>
    );
  };

  const renderBaseAccountConfTableRows = () => {
    return paginator.items.map((row, index) => {
      let baseAccountConf = row as BaseAccountConfiguration;
      return (
        <StyledTableRow key={index}>
          <StyledTableCell component="td" scope="row">
            {`${baseAccountConf.credit_base}`}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {baseAccountConf.assignment_date}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {baseAccountConf.pricing_group.code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {baseAccountConf.currency.code}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            {baseAccountConf.country.designation}
          </StyledTableCell>
          <StyledTableCell component="td" scope="row">
            <Button
              color="secondary"
              variant="contained"
              className={classes.subButton}
              value={baseAccountConf.id}
              onClick={(e) => openEditModal(e, baseAccountConf)}
            >
              <FormattedMessage id="sharedScreen.editBaseAccountConf" />
            </Button>
          </StyledTableCell>
        </StyledTableRow>
      );
    });
  };

  const renderBaseAccountConfTableHeader = () => {
    return (
      <TableRow>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.creditBase" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.assignmentDate" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.pricingGroupId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.currencyId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.countryId" />
        </StyledTableCell>
        <StyledTableCell align="left">
          <FormattedMessage id="sharedScreen.actions" />
        </StyledTableCell>
      </TableRow>
    );
  };

  return (
    <>
      {paginator !== null ? (
        <Box className={classes.root}>
          <Box className={classes.wrapper}>
            <Grid xs={12} sm={12} lg={12} container justify="flex-end">
              <Grid
                className={classes.myCard}
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={4}
                lg={3}
              >
                {modalType ? (
                  <AddBaseAccountConf
                    onSubmitCallback={fetchData}
                    currencies={currencies}
                    countries={countries}
                    pricingGroups={pricingGroups}
                  />
                ) : (
                  <EditBaseAccountConf
                    closeCallback={toggleEditBaseAccountModal}
                    onSubmitCallback={fetchData}
                    isOpened={editBaseAccountModalOpened}
                    currencies={currencies}
                    countries={countries}
                    pricingGroups={pricingGroups}
                    baseAccountConf={selectedBaseAccount}
                  />
                )}
              </Grid>
              <Grid
                container
                alignItems="flex-start"
                item
                xs={12}
                sm={8}
                lg={8}
              >
                {render()}
              </Grid>
            </Grid>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};
